<template>
  <div id="body">
    <section id="header">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">

            <h1 data-aos="fade-up">รางวัลผู้ให้บริการยอดเยี่ยม :</h1>
            <p data-aos="fade-up">
              โครงการผู้ให้บริการยอดเยี่ยม คือโครงการที่ช่วยสนับสนุนและโปรโมทคุณแม่บ้านชั้นนํา
              ที่สามารถให้บริการเกินมาตรฐาน<br>
              และสร้างความประทับใจสูงสุดให้กับลูกค้าของตนเอง
            </p>
          </div>
        </div>
      </div>

      <img src="/static/img/excellent/cover.png"
           class="d-md-block" alt="" data-aos="fade-up">
    </section>

    <section id="benefit-service">
      <div class="top-description">
        <div class="container">
          <div class="row">
            <div class="col-12 text-center content">
              <h1 data-aos="fade-up">ประโยชน์จากการเป็นผู้ให้บริการยอดเยี่ยม</h1>
              <p data-aos="fade-up">
                หากคุณได้รับรางวัลผู้ให้บริการยอดเยี่ยม คุณมีโอกาสที่จะได้รับการจองจากคุณลูกค้าที่มากกว่า
                เนื่องจากในโปรไฟล์ของคุณ<br>
                จะมีสัญลักษณ์การันตีคุณภาพโดย BeNeat ซึ่งลูกค้าส่วนใหญ่จะมองหาผู้ให้บริการที่มีคุณภาพสูงก่อน
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="middle-icon text-center">
        <img data-aos="fade-down"
             src="/static/img/excellent/Award.png" alt="" class="img-fluid">
      </div>

      <div class="description-content">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-4" data-aos="fade-up">
              <img src="/static/img/excellent/more_work.png" class="img-fluid" alt="">
              <h2>
                มีโอกาสได้รับงานที่มากกว่า
              </h2>
              <p>
                BeNeat มีการทําการตลาดเพื่อแนะนําผู้ให้บริการยอดเยี่ยม ผ่านทาง Email, แอปพลิเคชั่นและอีกหลายๆ
                ช่องทาง มีกระทั่งตัวกรองการค้นหาคุณแม่บ้านเพื่อให้คุณลูกค้าสามารถหาคุณได้อย่างง่ายดาย<br>และเรายังได้เพิ่มตราสัญลักษณ์ผู้ให้บริการยอดเยี่ยมลงในโปรไฟล์ของคุณอีกด้วย
                ซึ่งรับรองได้ว่าคุณจะโดดเด่นจริงๆ
              </p>
            </div>

            <div class="col-12 col-md-4 add-margin" data-aos="fade-up">
              <img src="/static/img/excellent/proudly.png" class="img-fluid" alt="">
              <h2>
                เข็มกลัดแห่งความภูมิใจ
              </h2>
              <p>
                ผู้ให้บริการยอดเยี่ยมจะได้รับ เข็มกลัดแห่งความภูมิใจ
                ซึ่งจะใช้สําหรับติดผ้ากันเปื้อนของคุณ
                ซึ่งผู้ท่ีพบเห็นจะทราบได้ทันทีว่า
                คุณคือ สุดยอดผู้ให้บริการที่รับรองผลงาน
                โดย BeNeat และคุณมีผลงานความโดดเด่น
              </p>
            </div>


            <div class="col-12 col-md-4 add-margin" data-aos="fade-up">
              <img src="/static/img/excellent/bonus.png" class="img-fluid" alt="">
              <h2>
                โบนัสออนท็อป
              </h2>
              <p>
                ถ้าคุณเป็นผู้ให้บริการยอดเยี่ยม คุณจะได้รับ
                โบนัสเพิ่มขึ้นอีก 5% จากโบนัสปกติประจําเดือนต่างๆที่ BeNeat จัดเป็นประจําให้กับผู้ให้บริการ
                **ยกเว้นโบนัสในลักษณะจับสลาก หรือโบนัสที่ไม่เข้าร่วมรายการนี้ ซึ่ง BeNeat จะแจ้งให้ทราบล่วงหน้าในประกาศ
              </p>
            </div>

          </div>
        </div>
      </div>

    </section>


    <section id="ways-to-great-service">
      <div class="top-description" data-aos="fade-up">
        <div class="container">
          <div class="row">
            <div class="col-12 text-center">
              <h1>วิธีเป็นผู้ให้บริการยอดเยี่ยม</h1>
              <p>
                ในทุกๆ 3 เดือนเราจะทําการประเมินว่าคุณผ่านเกณฑ์เหล่านี้ ตลอดระยะ 6 เดือนที่ผ่านมาหรือไม่<br>
                ถ้าผ่านเกณฑ์ คุณก็จะได้รับ หรือ สามารถรักษาสถานะผู้ให้บริการยอดเยี่ยมไว้ได้
              </p>
            </div>
          </div>
        </div>
      </div>


      <div class="description-content">
        <div class="container">
          <div class="row">

            <div class="col-6 box-one" data-aos="fade-up">
              <img src="/static/img/excellent/score_more_4_8.png" alt="" class="img-fluid">

              <h2>คะแนนรวม 4.8 ขึ้นไป</h2>

              <p>
                ผู้ให้บริการการยอดเยี่ยมจะต้องได้รับคะแนนเฉลี่ยโดยรวม อย่างน้อย 4.8
                ขึ้นไปโดยคํานวนจากรีวิวของลูกค้าของคุณ
              </p>
            </div>

            <div class="col-6 box-two" data-aos="fade-up">
              <img src="/static/img/excellent/service_minimum_2.png" alt="" class="img-fluid">

              <h2>การให้บริการอย่างน้อย เดือนละ 2 ครั้ง ตลอด 6 เดือนที่ผ่านมา</h2>

              <p>
                ผู้ให้บริการจะต้องรักษาระดับจํานวนครั้งในการให้บริการอย่างน้อย 2 ครั้ง ในทุกๆเดือน
                เพื่อเป็นการรักษาระดับฝีมือการให้บริการให้คงที่ และสร้างความมั่นใจให้กับลูกค้าของคุณว่า
                คุณมีการให้บริการอย่างต่อเนื่องผ่านระบบของ BeNeat
              </p>
            </div>
          </div>


          <div class="row mt-5">

            <div class="col-6 box-three" data-aos="fade-up">
              <img src="/static/img/excellent/dont_cancel.png" alt="" class="img-fluid">
              <h2>ไม่เคยยกเลิกงานตลอด 6 เดือนที่ผ่านมา (รับงานแล้วไปไม่ได้)</h2>
              <p>
                คุณต้องไม่เคยยกเลิกงานที่รับไปแล้วตลอด 6 เดือนที่ผ่านมา
                (ยกเว้นกรณีเหตุสุดวิสัย ซึ่งได้ติดต่อทาง Admin และได้รับการอนุโลมจาก BeNeat แล้ว)
                ซึ่งเป็นเรื่องสําคัญ เพราะคุณลูกค้าต้องการความมั่นใจว่า
                การจองบริการกับคุณ จะไม่ถูกคุณยกเลิกโดยไม่มีเหตุผลอันสมควร
              </p>
            </div>

            <div class="col-6 box-four" data-aos="fade-up">
              <img src="/static/img/excellent/no_report.png" alt="" class="img-fluid">
              <h2>ได้รับการร้องเรียนไม่เกิน 2 ครั้งตลอด 6 เดือนที่ผ่านมา</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<style scoped lang="scss">

  @import "../../../static/sass/page/excellent.scss";
  @import "~aos/dist/aos.css";
</style>


<script>
  import AOS from 'aos'

  export default {
    name: 'ExcellentProvider',
    created () {
      AOS.init({
        once: true,
        disabled: 'mobile',
        duration: 1000
      })
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/information/ExcellentProvider.vue